import React, {useContext, useEffect, useState} from 'react';
import Select, {createFilter} from 'react-select';
import makeAnimated from 'react-select/animated';
import {Context} from "../ApiClient";


export default function Filters(props) {

    // Getting object containing events from context, so we need to use braces
    let {documents}                   = useContext(Context);
    let {documentThemes} = useContext(Context);

    let [activeThemes, setActiveThemes]           = useState([]);
    let [searchValue, setSearchValue]                 = useState('');

    useEffect(() => {
        props.handleCallback({activeThemes, searchValue})
        // eslint-disable-next-line
    }, [activeThemes, documents, searchValue]);


    const filterConfig = {
        ignoreAccents: true, ignoreCase: true, trim: true
    }

    function formatAsOptions(array) {
        let options = [];

        if (Array.isArray(array)) {
            array.forEach(function (item) {
                options.push({value: item.title, label: item.title});
            });
        }

        return options;
    }

    return (// if events is not empty, then render the event list
        <div>
            <div className="fc-toolbar fc-header-toolbar">
                <input className={'searchBar'} type={"search"} onChange={e => setSearchValue(e.target.value)} placeholder={'Rechercher'}/>
                {documentThemes.length > 0 &&
                    <Select options={formatAsOptions(documentThemes)} isMulti isSearchable={true} placeholder={'Thématiques'}
                            openMenuOnClick={false} filterOption={createFilter(filterConfig)}
                            components={makeAnimated()}
                            onChange={setActiveThemes}
                            className="react-select"
                    />}
            </div>
        </div>)
}